import { defineMessages, IntlShape } from "react-intl";

import { getDisplayName } from "@app/util/ui";

export enum SortField {
  NAME = "name",
  CREATED_AT = "createdAt",
  FILE_SIZE = "file.contentLength",
  OWNER = "user.fullName",
  UPDATED_AT = "updatedAt",
  TYPE = "extension",
}

const messages = defineMessages<SortField>({
  [SortField.CREATED_AT]: {
    id: "component.resources.orderSelect.sort.field.createdAt",
    defaultMessage: "Date Created",
    description: "Date Created field label",
  },
  [SortField.FILE_SIZE]: {
    id: "component.resources.orderSelect.sort.field.fileSize",
    defaultMessage: "File Size",
    description: "File Size field label",
  },
  [SortField.NAME]: {
    id: "component.resources.orderSelect.sort.field.name",
    defaultMessage: "File Name",
    description: "Alphabetical field label",
  },
  [SortField.OWNER]: {
    id: "component.resources.orderSelect.sort.field.owner",
    defaultMessage: "Owner",
    description: "Owner field label",
  },
  [SortField.TYPE]: {
    id: "component.resources.orderSelect.sort.field.fileType",
    defaultMessage: "File Type",
    description: "File Type field label",
  },
  [SortField.UPDATED_AT]: {
    id: "component.resources.orderSelect.sort.field.updatedAt",
    defaultMessage: "Date Modified",
    description: "Date Modified field label",
  },
});

export const getSortFieldDisplayName = (intl: IntlShape, sortField: SortField) =>
  getDisplayName(intl, messages, sortField, "SortField");

export default getSortFieldDisplayName;
